import styled from "styled-components";

export const Container = styled.div`
	display: flex;
	flex-direction: column;
`;

export const RowHeader = styled.div`
	display: grid;
	grid-template-columns: 1fr 170px;
	justify-content: flex-start;
	align-items: center;
	gap: 0.4rem;
	padding: 0.2rem 0;
	border-bottom: 1px solid ${({ theme }) => theme.grayDark};
`;

export const AreaButtons = styled.div`
	display: flex;
	justify-content: center;
	gap: 1rem;
	margin: 1rem 0 0;
`;

export const Title = styled.h6`
	font-weight: bold;
`;

export const ContainerCollapse = styled.div`
	margin-top: 1rem;
	display: flex;
	flex-direction: column;
	gap: 1rem;
	background: ${({ theme }) => theme.pantone656C};
	padding: 1rem;
	border-radius: 8px;
	width: 100%;
`;

export const BodyBox = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	justify-content: space-between;
	transition: background 0.3s ease-out;
	width: 100%;

	&:hover {
		background: ${({ theme }) => theme.hoverGray};
	}
`;

export const ContainerFilters = styled.div`
	display: flex;
	justify-content: space-between;
	flex-direction: column;
	padding-top: 10px;
	padding-right: 10px;
	padding-left: 10px;
	gap: 1rem;
`;

export const ContainerScroll = styled.div`
	max-height: 400px;
	overflow-y: auto;
`;

export const GridCell = styled.span`
	margin: 0;
	font-size: 13px;
	word-break: break-all;
`;

export const ContainerGrid = styled.div`
	background-color: ${(props) => props.theme.white};
	border-bottom: 1px solid ${(props) => props.theme.icon};
	display: grid;
	align-items: center;
	padding-left: 16px;
	padding-right: 16px;
	gap: 1rem;
	grid-template-columns: 3fr 1fr 0fr;
`;

export const ContainerHeaderGrid = styled.div`
	background-color: ${(props) => props.theme.white};
	display: grid;
	align-items: center;
	gap: 1rem;
	grid-template-columns: 3fr 1fr 0fr;
`;
